// numberOfSentencesはワンポイントアドバイスの総数
export const numberOfSentences = 120;

export function getCommentId(number: number) {
  const id = ((number - 1) % numberOfSentences) + 1;
  const formattedId = id.toString().padStart(3, '0');

  return `advice_${formattedId}`;
}
